import { useEffect } from "@wordpress/element";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import Button from "@mui/material/Button";
import { addressDefaultValue } from "../../models";
import { fetchAddress, selectAddress } from "store/vino/addressSlice";
import Address from "../../Address";
import Contact from "../../Contact";
import AddressList from "./AddressList";

const ShippingAddress = ({ title, onChange }) => {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const address = useSelector(selectAddress);
	const { setValue, watch, formState } = useFormContext();
	const addNewAddress = watch("addNewAddress");

	useEffect(() => {
		if (user.isUserLoaded) {
			dispatch(fetchAddress());
		}
	}, [dispatch, user]);

	useEffect(() => {
		setValue("addNewAddress", address.length === 0);
	}, [address, setValue]);

	const handleCancelAddAddress = () => {
		setValue("addNewAddress", false);
	};

	const handleAddNew = () => {
		setValue("addNewAddress", true);
		const address = {
			...addressDefaultValue,
		};

		if (user.data && user.isUserLoaded) {
			address.firstName = user.data.firstName;
			address.lastName = user.data.lastName;
		}
		setValue("address", address);
	};

	return (
		<>
			<div className="flex mb-10 justify-between">
				<Typography className="text-16 font-medium">
					{title ? title : "Shipping Address"}
				</Typography>

				{address.length > 0 && addNewAddress && (
					<Button
						variant="contained"
						color="warning"
						onClick={handleCancelAddAddress}
					>
						Cancel
					</Button>
				)}

				{!addNewAddress && (
					<Button variant="contained" onClick={handleAddNew}>
						Add New
					</Button>
				)}
			</div>
			{!addNewAddress && (
				<AddressList
					address={address}
					onChange={onChange}
					errors={formState.errors}
				/>
			)}
			{addNewAddress && (
				<div className="w-full">
					<Contact />
					<Address />
				</div>
			)}
		</>
	);
};

export default ShippingAddress;
